import { Button, Stack, Typography } from '@mui/material';
import { Logout, DevicesOther } from '@mui/icons-material';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useCustomerAuth } from '@features/customer-reservations/CustomerAuthContext';
import { useReservationServicesQuery } from '@features/customer-reservations/queries';
import { CustomerPaths } from '@features/customer-reservations/routes';

export const BookingHeader = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useCustomerAuth();
  const { data: servicesData } = useReservationServicesQuery(isAuthenticated);

  return (
    <Stack direction="column" alignItems="flex-start" spacing={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
        <Stack direction="column" alignItems="flex-start" spacing={0.1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <EventAvailableIcon color="secondary" />
            <Typography
              variant="h5"
              color="secondary.main"
              fontSize={{ md: '1.3rem', xs: '1.1rem' }}
            >
              {intl.formatMessage({ id: 'customerAuth.bookingTitle' })}
            </Typography>
          </Stack>
          <Typography
            variant="body1"
            fontWeight="bold"
            color="info.main"
            fontSize={{ md: '1.2rem', xs: '1rem' }}
          >
            {servicesData?.clientName}
          </Typography>
        </Stack>
        <Button variant="outlined" startIcon={<Logout />} onClick={logout} size="small">
          {intl.formatMessage({ id: 'customerAuth.logout' })}
        </Button>
      </Stack>
    </Stack>
  );
};
